import * as ngCore from '@angular/core'

import * as state from '../../../../../../../../../../../state'
import * as element from '../../element'

@ngCore.Component({
  imports: [ngCore.forwardRef(() => element.Component)],
  selector: 'atn-mosaic-grid-row',
  standalone: true,
  styleUrl: './component.scss',
  templateUrl: './component.html',
})
export class Component {
  /**
   * @see {@link state.mosaic.endUser.currentRendering.models.page.Content.Element.Row}
   */
  public readonly rowSg =
    ngCore.input.required<state.mosaic.endUser.currentRendering.models.page.Content.Element.Row>(
      {
        alias: 'row',
      },
    )
}
